'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const ReadMore = require('common/ui/view/behavior/readmore');
const Template = require('balus/ui/template/additional/recommend/content-version.hbs');

class ActionContentVersionView extends Mn.View {
    get template() {
        return Template;
    }

    ui() {
        return {
            addCommentButton: '.add-comment-button'
        };
    }

    triggers() {
        return {
            'click @ui.addCommentButton': 'add:comment'
        };
    }

    templateContext() {
        const content = this.model.getWork().getTarget();
        const contentVersion = content.getLatestVersion();
        const contentType = contentVersion.getMetaData().getContentType();
        const path = contentVersion.getContent().path();

        return {
            contentVersion: contentVersion.toJSON(),
            contentType: contentType,
            path: path
        };
    }
}

class ActionContentVersionListView extends Mn.CollectionView {
    get childView() {
        return ActionContentVersionView;
    }

    get childViewEvents() {
        return {
            'add:comment': 'onAddComment'
        };
    }

    get collectionEvents() {
        return {
            'add remove': 'render'
        };
    }

    get behaviors() {
        return {
            ReadMore: {
                behaviorClass: ReadMore,
                showReadMore() {
                    return this.collection.length > this._limit;
                },
                onReadMore() {
                    this._limit = this._limit + 5;
                    this.render();
                }
            }
        };
    }

    initialize() {
        this._initialLimit = 1;
        this._limit = this._initialLimit;
    }

    filter(child, index) {
        return index < this._limit;
    }

    open() {
        this._limit = this._initialLimit;
        this.render();
    }

    onAddComment(child) {
        const content = child.model.getWork().getTarget();
        this.triggerMethod('add:content:comment', content);
    }
}

module.exports = ActionContentVersionListView;



// WEBPACK FOOTER //
// ./balus/ui/view/additional/recommend/content-list.js